import React, { useEffect, useState } from 'react';
import App from './app';
import { HashRouter } from 'react-router';
import { ConfigProvider, App as Antd } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { Auth } from './api/go';
import authState from './auth_state';

// 获取没有 query 部分的 url
function getBaseUrl() {
  const url = new URL(window.location.href);
  url.search = '';
  url.hash = '';
  return url.toString();
}

function redirectToFeishuLogin() {
  const FeishuAuthUrl = new URL('https://accounts.feishu.cn/open-apis/authen/v1/authorize');

  FeishuAuthUrl.searchParams.set('client_id', 'cli_a96ca3071df91bd4');
  FeishuAuthUrl.searchParams.set('response_type', 'code');
  FeishuAuthUrl.searchParams.set('redirect_uri', getBaseUrl());

  window.location.href = FeishuAuthUrl.toString();
}

export function FeishuAuthCheck() {
  const [checking, setChecking] = useState(true);
  useEffect(() => {
    // 先调用接口，检查是否存在登录态
    Auth.check().then((info) => {
      const hasUserId = !!info.user_id;
      if (hasUserId) {
        authState.set({
          userId: info.user_id,
          userName: info.user_name,
        });
        // 已登录，正常渲染应用
        setChecking(false);

        return;
      }

      // 检查是否存在飞书跳转回来的 code 参数
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      if (code) {
        // 存在 code，说明是飞书扫码登录回来的，调用接口获取用户信息
        Auth.feishuLogin({ code, redirect_uri: getBaseUrl() })
          .then(() => {
            return Auth.check();
          })
          .then((info) => {
            const hasUserId = !!info.user_id;
            if (hasUserId) {
              authState.set({
                userId: info.user_id,
                userName: info.user_name,
              });
              setChecking(false);

              return;
            }

            // 没有获取到授权信息，可能是 code 过期，重新发起
            redirectToFeishuLogin();
          });
        return;
      }

      // 没有 cokkie 登录态，也没有 code，说明没有登录，直接发起飞书扫码登录
      redirectToFeishuLogin();
    });
  }, []);

  if (checking) {
    return <h1>正在校验飞书授权状态...</h1>;
  }

  return (
    <HashRouter>
      <ConfigProvider locale={zhCN}>
        <Antd>
          <App />
        </Antd>
      </ConfigProvider>
    </HashRouter>
  );
}
